import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography, TypographyProps, withTypography } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

const styles = StyleSheet.create({
  contentWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: 500,
    padding: spacing.$4,
    width: '100%',
  },
  contentText: {
    marginBottom: spacing.$10,
  },
  contentHeader: {
    marginBottom: spacing.$4,
  },
});

export const ContentWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.contentWrapper, style] });

export const ContentText = withTypography({
  textAlign: 'center',
  style: styles.contentText,
});

export const ContentHeader = ({ style, ...props }: TypographyProps) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return React.createElement(Typography, {
    ...props,
    variant: 'headerOne',
    textAlign: 'center',
    fontSize: isDesktopLarge ? 30 : undefined,
    lineHeight: isDesktopLarge ? 36 : undefined,
    style: [styles.contentHeader, style],
  });
};
